// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"767":"component---themes-gatsby-theme-beluga-src-templates-index-tsx","970":"component---themes-gatsby-theme-beluga-src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"88":"486622e9377ecf17f3c7","767":"7438e4a2aac338a8888c","943":"520af1090c7f36442a7c","970":"0e9b164d39ac62f5dd53"}[chunkId] + ".js";
};